export const estado = [
  { nombre: 'Todos', valor: '' },
  { nombre: 'Activo', valor: 'true' },
  { nombre: 'Inactivo', valor: 'false' },
];

export const abiertasCerradas = [
  { nombre: 'Todos', valor: '' },
  { nombre: 'Abiertas', valor: 'true' },
  { nombre: 'Cerradas', valor: 'false' },
];
